import { createContext, useMemo, useContext, useRef } from 'react';
import { FilterContextType } from './types';
import { AssetType } from '../AggregatesContext/types';

export const FilterContext = createContext<FilterContextType>({
  multiSelectSelectedAssets: { current: [] },
});

const FilterContextProvider = (props: any) => {
  const multiSelectSelectedAssets = useRef<AssetType[]>([]);

  const filterContext: FilterContextType = useMemo(() => {
    return {
      multiSelectSelectedAssets,
    };
  }, [multiSelectSelectedAssets]);

  return <FilterContext.Provider value={filterContext} {...props} />;
};
export const useFilter = () => useContext(FilterContext);
export default FilterContextProvider;
